import { ReactElement } from 'react';

import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { commonTranslationKeys } from '@dreryk/react-common';

import {
   HealthcareProviderLocationIdentifier,
   useGetHealthcareProviderLocationByIdentifierCqrsGet,
} from '~libs.shared.healthcare-provider-location';

export type HealthcareProviderLocationPart = {
   name: string;
};

type WaitlistEntryConfirmReservationHealthcareLocationChildrenRenderProps = {
   locationPart: HealthcareProviderLocationPart;
};

type WaitlistEntryConfirmReservationHealthcareLocationProps = {
   healthcareLocationIdentifier: HealthcareProviderLocationIdentifier;
   children: (props: WaitlistEntryConfirmReservationHealthcareLocationChildrenRenderProps) => ReactElement;
};

export const WaitlistEntryConfirmReservationHealthcareLocationLoader = (
   props: WaitlistEntryConfirmReservationHealthcareLocationProps
): ReactElement => {
   const {
      data: healthcareProviderLocation,
      loading: healthcareProviderLocationLoading,
      error: healthcareProviderLocationError,
   } = useGetHealthcareProviderLocationByIdentifierCqrsGet({
      type: props.healthcareLocationIdentifier.type,
      id: props.healthcareLocationIdentifier.id,
   });

   if (!healthcareProviderLocation || healthcareProviderLocationLoading) {
      return <LoaderSpinner />;
   }

   if (healthcareProviderLocationError) {
      return (
         <Message
            testId={'healthcareProviderLocationError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({ locationPart: healthcareProviderLocation });
};
